import './index.css';
import { Link } from 'react-router-dom';
import logo_hogcloud1 from "../../assets/images/hogcloud-logo1.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faHome, faShoppingCart, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { faXTwitter, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <Link to="/" className="footer-logo-link">
          <img
            src={logo_hogcloud1}
            alt="hogcloud logo pig in cloud"
            className="footer-logo"
          />
        </Link>

        <div className="footer-meta">
          <span className="footer-copy">
            &copy; 2021 - {new Date().getFullYear()} Hogcloud, Inc.
          </span>
          <Link to="/partners" className="privacy-link">Partners</Link>
          <Link to="/tc" className="privacy-link">Terms</Link>
          <Link to="/privacy" className="privacy-link">Privacy</Link>
        </div>
      </div>

      <div className="footer-right">
        <div className="footer-pill">
          <a rel="noreferrer" href="https://x.com/hogcloud" target="_blank" className="footer-icon-link" aria-label="X">
            <FontAwesomeIcon icon={faXTwitter} />
          </a>
          <a rel="noreferrer" href="https://facebook.com/hogcloud" target="_blank" className="footer-icon-link" aria-label="Facebook">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a rel="noreferrer" href="https://instagram.com/hogcloud" target="_blank" className="footer-icon-link" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>

        <div className="footer-pill">
          <Link to="/" className="footer-icon-link" aria-label="Home">
            <FontAwesomeIcon icon={faHome} />
          </Link>
          <Link to="/cart" className="footer-icon-link" aria-label="Cart">
            <FontAwesomeIcon icon={faShoppingCart} />
          </Link>
          <Link to="/contact" className="footer-icon-link" aria-label="Contact">
            <FontAwesomeIcon icon={faAddressBook} />
          </Link>
          <a href="mailto:sales@hogcloud.net" className="footer-icon-link" aria-label="Email">
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
